import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Alert } from '../../ui/Alert';

export const MergeContactsModal = ({ contact, matches, onMerge, onClose }) => {
  const [confirmId, setConfirmId] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleMerge = async (other) => {
    setBusy(true);
    setError('');
    try {
      await onMerge(contact.id, other.id);
    } catch (err) {
      setError(err.message || 'Could not merge these contacts.');
      setBusy(false);
      setConfirmId(null);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
      <div className="bg-white w-full max-w-md rounded-3xl p-6 space-y-4 shadow-xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-bold text-slate-900 tracking-tight">Possible duplicates</h2>
        <p className="text-sm text-slate-600">
          These contacts share an email or phone with <span className="font-bold">{contact.full_name || 'this contact'}</span>.
          They are only merged if you choose to. Merging moves Moments and card submissions onto
          this contact, fills in any blank details, and removes the other contact record.
        </p>
        {error && <Alert variant="error" message={error} />}
        <ul className="space-y-3">
          {matches.map((m) => (
            <li key={m.id} className="rounded-2xl border border-slate-200 p-3">
              <p className="text-sm font-bold text-slate-900">{m.full_name || 'Unnamed contact'}</p>
              <p className="text-xs text-slate-500">{[m.email, m.phone, m.company].filter(Boolean).join(' · ') || 'No details'}</p>
              <div className="mt-3 flex justify-end gap-2">
                {confirmId === m.id ? (
                  <>
                    <Button variant="secondary" size="sm" onClick={() => setConfirmId(null)} disabled={busy}>Cancel</Button>
                    <Button variant="danger" size="sm" onClick={() => handleMerge(m)} isLoading={busy}>Confirm merge</Button>
                  </>
                ) : (
                  <Button variant="secondary" size="sm" onClick={() => setConfirmId(m.id)} disabled={busy}>
                    Merge into {contact.full_name || 'this contact'}
                  </Button>
                )}
              </div>
            </li>
          ))}
        </ul>
        <div className="flex justify-end">
          <Button variant="secondary" onClick={onClose} disabled={busy}>Close</Button>
        </div>
      </div>
    </div>
  );
};